import { forwardRef, memo } from "react";
import styleSheet from "./style.module.scss";
import SyIcon from "../../components/sy-icon";
import SyTooltip from "../../components/sy-tooltip";
import { InputFormProps } from "./orb-input-interface";
import ObrErrorMessage from "../orb-error-message";
import { useTranslation } from "react-i18next";

const OrbInput = forwardRef<HTMLInputElement, InputFormProps>(
  (props: InputFormProps, ref) => {
    const {
      placeholder = "",
      type,
      label,
      onChange,
      onChangeBlur,
      onClickEnter,
      inputType = "dark",
      handleFocus,
      keyClick = null,
      className = "",
      size = "",
      inputHidden = false,
      value,
      checked,
      showError = true,
      errorMessage = "",
      iconStyle = "round",
      iconType = "symbols",
      withIcon = false,
      iconName = "near_me",
      selected,
      id,
      onClick,
      iconTip,
      ...rest
    } = props;

      const { t } = useTranslation();

    const enterClick= (e:any)=>{
      const inputElement = document.getElementById(id) as HTMLInputElement;
      const inputData =
        inputElement && inputElement.value ? inputElement.value : null;
      if (e.key === keyClick) {
        e.preventDefault(); 
         onClickEnter(inputData);
      }

    }

    const onClickIcon = () => {
      const inputElement = document.getElementById(id) as HTMLInputElement;
      const inputData =
        inputElement && inputElement.value ? inputElement.value : null;
      onClick && onClick(inputData);
    };

    return (
      <div className=" position-relative w-100">
        {label && <p className="mb-1 text-white mohave main-font">{label}</p>}
        <input
          id={id?id: placeholder}
          ref={ref}
          onKeyDown={enterClick}
          placeholder={placeholder}
          onChange={onChange}
          autoComplete="new-password"
         checked={type === "checkbox" ? props.checked : undefined}
  value={type !== "checkbox" ? value : undefined}
          type={type}
          onBlur={onChangeBlur}
          onFocus={handleFocus}
          className={`${styleSheet[inputType]} ${
            selected ? styleSheet.selected : ""
          } ${className} ${styleSheet[size]}  ${
            inputType !== `hidden` && `mohave  `
          }  ${withIcon ? "pe-5" : ""} lh-1`}
          {...rest}
        />
        {showError && (
          <div className={`${styleSheet.error} ${styleSheet.error_animate} d-flex justify-content-end `}>
            <ObrErrorMessage message={t(errorMessage)} />
          </div>
        )}
        {withIcon && (
          <SyTooltip title={iconTip}>
            <span>
              <SyIcon
                className={
                  "position-absolute pointer end-0 top-50  translate-middle-y me-2"
                }
                iconStyle={iconStyle}
                iconType={iconType}
                name={iconName}
                iconColor="rgba(146, 143, 148, 1)"
                onClick={onClickIcon}
              />
            </span>
          </SyTooltip>
        )}
      </div>
    );
  }
);

export default memo(OrbInput);
